export enum SimpleTooltipPosition {
  Top,
  Right,
  Bottom,
  Left
};
